import config from '@/src/editorConfig.js'

const kioskMenuItems = config.contentTypes
  .filter((type) => type.menu)
  .map((type) => {
    return { name: type.name, title: type.label, icon: null }
  })
console.log(kioskMenuItems)


export default {
  navRoutePaxTotals: [
    {
      name: 'paxTotalsByNat',
      title: 'Nationality',
      icon: 'passport',
    },
    {
      name: 'paxTotalsByDest',
      title: 'Destinations',
      icon: 'island',
    },

    {
      name: 'paxTotalsByTour',
      title: 'Tour Operator',
      icon: 'flight-ticket',
    },
  ],
  loggedInNavRoutesSystemUsage: [
    {
      name: 'usageReport',
      title: 'Usage Report',
      icon: 'usage',
    },
    {
      name: 'usageWeeklyProfile',
      title: 'Weekly Profile',
      icon: 'prediction',
    },
    {
      name: 'usageCheckin',
      title: 'Checkin Report',
      icon: 'wheeledLuggage',
    },
  ],
  loggedInNavRoutesKiosk: kioskMenuItems,
}
